import { useState,useEffect } from "react";
import AxiosFetchData from "../pages/AxiosFetchData";
import { useNavigate, useParams } from 'react-router-dom';
import ConfirmationButton from '../components/ConfirmationButton';
import { styled } from '@mui/material/styles';
import { CatchWrapperAsync } from "../utils/catchwrapper";
import Bindcomponent from "../utils/bindcomponent";
import useStoreUser from "../state/UserState";
import { set } from "date-fns";
export const  useUserListHook = (setmessage, setRows, setTypeError, setSelectedRoles, setIdStatus,setChipData,setConfirmStatusOpen, chipData,idStatus) =>{
    // const { fetchData, rows } = useStoreUser((state) => {
    //   return { fetchData: state.fetch,rows : state.rows};
    // });
  
    const Navigate = useNavigate();
    const [roleAccess, setRoleAccess] = useState('')
    const [role, setRole] = useState('')
    
    useEffect(() =>
    {
        fetchData()
    },[])
        
    const fetchData = async () => {
        CatchWrapperAsync(async ()=>{
          const response = await AxiosFetchData.get(`GetUserList`).refreshToken(Navigate,"users",true);
          if(response){
            setRoleAccess(response.roleaccess)
            setRole(response.decode.role)
            setRows(response.data);
          }
        },setmessage,setTypeError)
    }

    const handleDeleteStatus = async (data) => {
        CatchWrapperAsync(async ()=>{
          const response = await AxiosFetchData.delete(`DeleteUser/${data}`).refreshToken(Navigate,"users");
          if(response){
            setRows((prevRows) => prevRows.filter((row) => row.id !== data));
          }
          setmessage(response.data);
        },setmessage,setTypeError)
    };

    const columns = [
          { field: 'rowNumber', headerName: 'No.', width: 80 },
          { field: 'nama_client', headerName: 'Name', width: 250 },
          { field: 'email', headerName: 'Email', width: 250 },
          { field: 'role', headerName: 'Role ID', width: 150 },
          { field: 'roles', headerName: 'Role Name', width: 250 },
          {
            field: 'pass',
            headerName: 'Password',
            width: 150,
            renderCell: (params) => (
              <>
               *****
              </>
              
            ),
          },
          {
            field: 'actions',
            headerName: 'Actions',
            width: 150,
            renderCell: (params) => (
              <>
               {/* {(params.row.kode.toUpperCase() !== 'SUPERADMIN' ||  role.toUpperCase() =='SUPERADMIN') && ( */}
               {(params.row.kode.toUpperCase().includes('SUPERADMIN') == false ||  role.toUpperCase().includes('SUPERADMIN') == true) && (
                 <button
                  onClick={() => {
                    //setChipData([])
                    handleEdit(params.row)
                  }} // Pass the project ID to the edit function
                  className="btn btn-primary mr-2"
                  disabled={!roleAccess.UPDATE}
                >
                  Edit
                </button>
              )}
             
              {/* {(params.row.kode.toUpperCase() !== 'SUPERADMIN'  || role.toUpperCase() =='SUPERADMIN') && ( */}
              {(params.row.kode.toUpperCase().includes('SUPERADMIN') == false  || role.toUpperCase().includes('SUPERADMIN') == true) && (
                <Bindcomponent component='ConfirmationButton' classname='btn btn-danger' text="Do you want delete this data?" type="button" disabled={!roleAccess.DELETE} onClick={() => handleDeleteStatus(params.row.id)}>Delete</Bindcomponent>
              )}
              </>
            ),
        },
    ];

    const handleEdit = (data) => {
          setSelectedRoles('')
          setIdStatus(data.id)
          setName(data.nama_client)
          setEmail(data.email)
          
          if(chipData.filter((item) => item.value == data.role).length == 0){
            var roleNameList = data.rolename.split(',')
            for(let i=0;i < roleNameList.length;i++){
              chipData.push({value : roleNameList[i].split(' - ')[0],label : roleNameList[i]})
            }
            
            setChipData(chipData)
          }
         
          setConfirmStatusOpen(true)
    };

    function AddProjectData() {
          setIdStatus(null)
          setName('');
          setEmail('');
          setPassword('');
          setConfirmPassword('');
          setSelectedRoles('')
          setConfirmStatusOpen(true);
          setChipData([])
    }

    const handleDelete = (chipToDelete) => () => {
          if(chipData.length > 1){
            setChipData((chips) => chips.filter((chip) => chip.value !== chipToDelete.value));
          }
         
    };

    const ListItem = styled('li')(({ theme }) => ({
          margin: theme.spacing(0.5),
    }));

    async function AddStatus(e){
            e.preventDefault(); 
            var roles='';
            if(chipData.length == 0){
              setmessage("Please select a role")
              setTypeError("error")
              return;
            }
            for(let i=0;i < chipData.length ; i++){
              roles += chipData[i].value + ',';
            }
       
            if(idStatus)
            {
              var data = {
                id: idStatus,
                name : name,
                email : email,
                password :  password,
                confirmpassword :  confirmPassword,
                role :  roles.substring(0, roles.length - 1)
              }

              var response = await AxiosFetchData.post(`UpdateUser`, data).refreshToken(Navigate,"users")
              if(response){
                setConfirmStatusOpen(false);
                setmessage(response.data.message);
              }
            }else{
              var data = {
                name : name,
                email : email,
                password :  password,
                confirmpassword :  confirmPassword,
                role :  roles.substring(0, roles.length - 1)
              }
             
              var response = await AxiosFetchData.post(`Register`, data).refreshToken(Navigate,"users")
        
              if(response){
                setConfirmStatusOpen(false);
                setmessage(response.data.message);
              }
            }
            setChipData([])
            await fetchData();
    }

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
         
    return {roleAccess,role,  columns, AddProjectData, handleDelete, ListItem, AddStatus,name,setName,email,setEmail,password,setPassword,confirmPassword,setConfirmPassword}
       
}